/**
 * Debug utilities for DOM Observer Context
 * These helpers are exposed to window in development mode for debugging
 */

/**
 * Inspect DOM structure for debugging
 */
export function debugDOMObserver(): void {
  // Check for grids
  const grids = document.querySelectorAll('[role="grid"]');
  console.log('Grids found:', grids.length);

  // Check for rows
  const allRows = document.querySelectorAll('[role="row"]');
  const selectedRows = document.querySelectorAll('[role="row"][aria-selected="true"]');
  console.debug('Rows found:', {
    total: allRows.length,
    selected: selectedRows.length,
  });
}

/**
 * No-op cleanup function
 */
function noop() {
  // Intentionally empty
}

/**
 * Setup debug helpers in development mode
 */
export function setupDebugHelpers(runAllScans: () => void): () => void {
  if (process.env.NODE_ENV !== 'development') {
    return noop;
  }

  (window as any).__debugDOMObserver = debugDOMObserver;

  (window as any).__runDOMObserverScans = () => {
    runAllScans();
  };

  // Cleanup function
  return () => {
    delete (window as any).__debugDOMObserver;
    delete (window as any).__runDOMObserverScans;
  };
}
